<template>
  <img
    alt="How it works desktop"
    :src="desktopImage"
  >
</template>

<script>
// Images
import howItWorksDesktop from '@/assets/images/nlp/howItWorksDesktop.png'

export default {
  name: 'NlpHowItWorksImageDesktop',
  computed: {
    desktopImage() {
      return howItWorksDesktop
    },
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>